<div class="filter-container">
    <div class="switch-row">
        <label class="title-label" for="selectButton">Date/Time Format</label>
        <p-togglebutton
          [dt]="toggleButton"
          [onLabel]="'LCL'"
          [offLabel]="'UTC'"
          [(ngModel)]="timeFormatLocal"
          size="small"
          style="height: 32px;"
        ></p-togglebutton>
    </div>
    <div class="switch-row">
        <div>Sort Order</div>
        <button class="sort-button" (click)="onSortOrderClicked()">
            {{sortOrder === 0 ? 'Ascending' : 'Descending'}}
            <i class="sort-icon {{sortOrder === 0 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'}}"></i>
        </button>
    </div>
    <div class="switch-col">
        <div class="switch-row">
            <div class="row">
                <div class="tag flt">FLT</div>
                <label for="flights-Label">Flights</label>
            </div>
            <p-toggleswitch 
                [dt]="toggleSwitch"
                [(ngModel)]="flights" 
                [style]="{'margin-top': '0.5rem'}" />
        </div>
        <div class="switch-row">
            <div class="row">
                <div class="tag dh">DH</div>
                <label for="deadhead-Label">Deadhead</label>
            </div>
            <p-toggleswitch 
                [dt]="toggleSwitch"
                [(ngModel)]="deadhead" 
                [style]="{'margin-top': '0.5rem'}" />
        </div>
        <div class="switch-row">
            <div class="row">
                <div class="tag cx">CX</div>
                <label for="cancelled-Label">Cancelled</label>
            </div>
            <p-toggleswitch 
                [dt]="toggleSwitch"
                [(ngModel)]="cancelled" 
                [style]="{'margin-top': '0.5rem'}" />
        </div>
    </div>
    <p class="footer">Sort Order and Date/Time Format are global settings.</p>
    <div class="error">
        <span [hidden]="flights === true || deadhead === true || cancelled === true">
            At least one filter item must be selected on.
        </span>
    </div>
    <div class="button-container" *ngIf="appService.theme$ | async as theme">
        <p-fluid>
            <p-button
                [dt]="saveButton" 
                [disabled]="flights === false && deadhead === false && cancelled === false"
                (onClick)="onSave()"
                >Save
            </p-button>
        </p-fluid>
    </div>
</div>
